import makeArrayMethod from './shared/makeArrayMethod';
export default makeArrayMethod( 'pop' ).path;

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/prototype/pop.js.map
